"use strict";

var moment = require('moment');

var update_reprint_reasons = ['NEW_ITEMS', 'TYPOGRAPHICAL_ERROR', 'CHANGES_AFTER_APPROVAL', 'PRE_PRESS_ISSUES', 'PRINTING_ISSUES_PRODUCTION']; // TODO: Abstract this to JSON config

function defaultSubject(printJob) {
  var printing_type = printJob.printing_type,
      name = printJob.name,
      is_reprint = printJob.is_reprint,
      is_test_print = printJob.is_test_print,
      reprint_reason = printJob.reprint_reason,
      is_for_covid = printJob.is_for_covid;
  var subject = 'Shine Order - ';

  if (printing_type !== 'STD') {
    subject += 'RUSH - ';
  }

  if (name) {
    subject += name;
  }

  if (is_reprint) {
    if (update_reprint_reasons.includes(reprint_reason)) {
      subject += ' - UPDATED';
    } else {
      subject += ' - REPRINT';
    }
  }

  if (is_test_print) {
    subject += ' - Test Print';
  }

  if (is_for_covid) {
    subject += ' - COVID';
  }

  return subject;
}

function sampleSets(printJob) {
  return defaultSubject(printJob) + ' - ' + moment().format('MMDDYY');
}

function tableNumbers() {
  return 'Shine Order - RUSH - Table Numbers - ' + moment().format('MMDDYY');
}

function colorChartKits() {
  return 'Shine Order - Color Chart Kits';
}

function customSamples(printJob) {
  var subject = 'Shine Order - RUSH - Custom Samples - '; // [Paper Type] - [Date sent to print]';

  switch (printJob.products[0].paper_type) {
    case 'Ivory Matte':
      subject += 'Ivory Matte - ';
      break;

    case 'White Shimmer':
      subject += 'White Shimmer - ';
      break;

    default:
      subject += 'White Matte - ';
  }

  subject += moment().format('MMDDYY');
  return subject;
}

module.exports = function (printJobs, shipments, templateName, printerOptions, settings) {
  var fns = {
    TableNumbers: tableNumbers,
    TestPrints: defaultSubject,
    SampleSets: sampleSets,
    ColorChartKits: colorChartKits,
    FullOrders: defaultSubject,
    CustomSamples: customSamples
  };
  var f = fns[templateName];

  if (typeof f !== 'function') {
    throw new Error("".concat(templateName, " is not an email subject function"));
  }

  var printJob = Array.isArray(printJobs) ? printJobs[0] : printJobs;
  var shipment = Array.isArray(shipments) ? shipments[0] : shipments;
  return f(printJob, shipment, templateName, printerOptions, settings);
};